import React, { useState } from 'react';
import { FaEdit, FaSave, FaTimes, FaTrash } from 'react-icons/fa';

import '../css/AicaPcView.css';
import { common } from '../utils/common';
import SearchBox from './SearchBox';

function AicaPcView({
  user,
  handlePatientSelect,
  showSearchPopup,
  setShowSearchPopup,
  isRecording,
  getDisplayText,
  patientList,
  selectedPatient,
  editingIndex,
  editName,
  setEditName,
  handleSaveName,
  setEditingIndex,
  handleEditName,
  handleDeletePatient,
  handleMedicalHistory,
  medicalHistory,
  selectedHistory,
  handleHistorySelect,
  handleDeleteHistory,
  startRecording,
  stopRecording,
  isProcessing,
  audioFilePath,
  audioPlayerRef,
  canvasRef,
  transcriptionText,
  summaryText,
  deleteConfirm,
  cancelDelete,
  confirmDelete,
  deleteHistoryConfirm,
  cancelDeleteHistory,
  confirmDeleteHistory,
}) {
  const [tab, setTab] = useState('consult');
  const [listOpen, setListOpen] = useState(false);
  const patientName = selectedPatient?.patientName || '';

  const openHistory = (history) => {
    handleHistorySelect(history);
    setTab('consult');
  };

  const pickPatient = (patient) => {
    if (editingIndex !== null) return;
    handleMedicalHistory(patient);
    setListOpen(false);
    setTab('consult');
  };

  return (
    <div className={`aica-pc ${isRecording ? 'is-recording' : ''}`}>
      <div className="aica-pc-head">
        <SearchBox
          user={user}
          onPatientSelect={(patient) => {
            handlePatientSelect(patient);
            setListOpen(false);
            setTab('consult');
          }}
          showSearchPopup={showSearchPopup}
          setShowSearchPopup={setShowSearchPopup}
        />

        <button
          type="button"
          className="aica-pc-patient"
          disabled={isRecording}
          onClick={() => setListOpen((open) => !open)}
        >
          <span>
            <strong>{patientName || '환자를 선택하세요'}</strong>
          </span>
          <span className="aica-pc-chev">{listOpen ? '▴' : '▾'}</span>
        </button>

        {listOpen && !isRecording && (
          <div className="aica-pc-patients">
            {patientList && patientList.length > 0 ? patientList.map((patient, index) => (
              <div
                key={index}
                className={`aica-pc-patient-row ${patientName === patient.patientName ? 'on' : ''}`}
                onClick={() => pickPatient(patient)}
              >
                {editingIndex === index ? (
                  <div className="aica-pc-edit" onClick={(e) => e.stopPropagation()}>
                    <input
                      value={editName}
                      maxLength={20}
                      onChange={(e) => setEditName(e.target.value || null)}
                      placeholder="환자 이름 입력"
                      autoFocus
                    />
                    <FaSave
                      title="저장"
                      onClick={() => handleSaveName(index, patient.patientName)}
                    />
                    <FaTimes title="취소" onClick={() => setEditingIndex(null)} />
                  </div>
                ) : (
                  <>
                    <span>{patient.patientName || ''}</span>
                    <FaEdit
                      title="이름 수정"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEditName(index, patient.patientName);
                      }}
                    />
                    <FaTrash
                      title="환자 삭제"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeletePatient(index, patient);
                      }}
                    />
                  </>
                )}
              </div>
            )) : (
              <div className="aica-pc-empty">최근 환자가 없습니다.</div>
            )}
          </div>
        )}

        <div className="aica-pc-tabs">
          <button type="button" className={tab === 'consult' ? 'on' : ''} onClick={() => setTab('consult')}>
            {getDisplayText('consultation')}
          </button>
          <button type="button" className={tab === 'history' ? 'on' : ''} onClick={() => setTab('history')} disabled={isRecording}>
            {getDisplayText('medicalHistory')}
          </button>
          <button type="button" className={tab === 'summary' ? 'on' : ''} onClick={() => setTab('summary')}>
            {getDisplayText('summary')}
          </button>
        </div>
      </div>

      <div className="aica-pc-body">
        {tab === 'consult' && (
          <div className="aica-chat-content aica-pc-sheet">
            {isRecording && <div className="aica-pc-live">녹음중</div>}
            {isRecording && (
              <div className="waveform-container-overlay">
                <canvas ref={canvasRef} className="audio-waveform" />
              </div>
            )}
            <textarea
              className="aica-chat-textarea aica-pc-text"
              value={transcriptionText}
              readOnly
              placeholder="상담을 시작하면 내용이 여기에 표시됩니다."
            />
          </div>
        )}

        {tab === 'history' && (
          <div className="aica-pc-sheet">
            {/* 웹은 목록 첫 환자의 내역을 미리 채우지만 선택 표시는 하지 않는다.
                PC는 환자를 고르기 전에는 그 내역을 보여 주지 않는다. */}
            {!patientName && (
              <div className="aica-pc-empty">환자를 선택하세요.</div>
            )}
            {patientName && medicalHistory.length === 0 && (
              <div className="aica-pc-empty">이전 내역이 없습니다.</div>
            )}
            {patientName && medicalHistory.map((history, index) => (
              <div
                key={index}
                className={`aica-pc-history ${selectedHistory?.seqNo === history.seqNo ? 'on' : ''}`}
                onClick={() => openHistory(history)}
              >
                <span>{common.formatDateTimeDisplay(history.startDt)}</span>
                <FaTrash
                  title="상담 내역 삭제"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteHistory(index, history);
                  }}
                />
              </div>
            ))}
          </div>
        )}

        {tab === 'summary' && (
          <div className="aica-chat-content aica-pc-sheet">
            <textarea
              className="aica-pc-text"
              value={summaryText}
              readOnly
              placeholder="상담 요약이 여기에 표시됩니다."
            />
          </div>
        )}
      </div>

      {audioFilePath && (
        <div className="audio-player-container aica-pc-audio">
          <audio
            id="audioPlayer"
            ref={audioPlayerRef}
            controls
            className={`audio-player ${audioFilePath === 'disabled' ? 'disabled' : ''}`}
            disabled={audioFilePath === 'disabled'}
          >
            <source src={audioFilePath === 'disabled' ? '' : audioFilePath} type="audio/wav" />
          </audio>
        </div>
      )}

      <div className="aica-pc-actions">
        <button type="button" className="start" onClick={startRecording} disabled={isRecording}>
          상담시작
        </button>
        <button type="button" className="stop" onClick={stopRecording} disabled={!isRecording || isProcessing}>
          상담종료
        </button>
      </div>

      {deleteConfirm.show && (
        <div className="delete-popup-overlay">
          <div className="delete-popup">
            <div className="delete-popup-header">
              <h3>환자 삭제</h3>
            </div>
            <div className="delete-popup-content">
              <p>
                <strong>"{deleteConfirm.patient?.patientName}"</strong> 환자를 삭제하시겠습니까?
              </p>
              <p className="delete-warning">
                ⚠️ 삭제된 환자의 모든 {getDisplayText('consultation')} 내역이 함께 삭제됩니다.
              </p>
            </div>
            <div className="delete-popup-buttons">
              <button className="cancel-btn" onClick={cancelDelete}>취소</button>
              <button className="delete-btn" onClick={confirmDelete}>삭제</button>
            </div>
          </div>
        </div>
      )}

      {deleteHistoryConfirm.show && (
        <div className="delete-popup-overlay">
          <div className="delete-popup">
            <div className="delete-popup-header">
              <h3>{getDisplayText('consultation')} 내역 삭제</h3>
            </div>
            <div className="delete-popup-content">
              <p>
                <strong>"{common.formatDateTimeDisplay(deleteHistoryConfirm.history?.startDt)}"</strong> {getDisplayText('consultation')} 내역을 삭제하시겠습니까?
              </p>
              <p className="delete-warning">
                ⚠️ 삭제된 {getDisplayText('consultation')} 내역은 복구할 수 없습니다.
              </p>
            </div>
            <div className="delete-popup-buttons">
              <button className="cancel-btn" onClick={cancelDeleteHistory}>취소</button>
              <button className="delete-btn" onClick={confirmDeleteHistory}>삭제</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AicaPcView;
